import React from 'react';
import { useAntdColumnResize } from 'react-antd-column-resize';
// import {Table} from "antd";
import { Table } from 'src/library/components'
const App = (props) => {
    const { columns, dataSource, rowSelection, ...others } = props
    let { resizableColumns, components} =
        useAntdColumnResize(() => {
            let newColumns = [...columns]
            return {columns: newColumns, minWidth: 100 };
        }, [columns.length]);
    return (
        <Table
            columns={resizableColumns}
            components={components}
            pagination={false}
            rowSelection={rowSelection}
            {...others}
            dataSource={dataSource}
            // scroll={{ x: tableWidth }}
        />
    );
};

export default App;
